<template>
  <v-container fluid>
    <schedules :campaign-filter="true"></schedules>
    <data-table
      @generateReport="generateReport"
      :filters="filters"
      :limit="6"
      url="/campaigns"
      fields="name,status,template_code,channel,start_date,delivery_option"
      content="campaignLists"
      searchFields="name,template_code,channel">
      <template slot="title">
        <v-layout justify-center align-center>
          <v-flex md6 class="headline">
            Campañas
          </v-flex>
          <v-flex md2 pr-2>
            <v-btn
              block large
              @click="generateReport({})">
                <v-icon small>fas fa-download</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md2 pr-2>
            <v-btn class="k-orange-linear white--text" block large @click="dialogBaseGenerator = !dialogBaseGenerator">
              Generar base
            </v-btn>
          </v-flex>
          <v-flex md2 pr-2>
            <v-btn class="k-orange-linear white--text" block large @click="dialogBase = !dialogBase">
              Ejemplo de base
            </v-btn>
          </v-flex>
          <v-flex md2>
            <v-btn class="k-orange-linear white--text" block large @click="dialog = !dialog">
              Añadir campaña
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg3>
          <v-select
            v-model="filters.user_id"
            :items="users"
            class="white--text"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-select
            v-model="filters.category"
            :items="categories"
            class="white--text"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses"
            item-value="value"
            item-text="name"
            class="white--text"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters.date"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
              <v-text-field
                slot="activator"
                v-model="formatedDate"
                class="k-orange-linear-text"
                prepend-icon="event"
                label="Periodo"
                readonly
                solo>
              </v-text-field>
              <v-date-picker
                v-model="filters.date"
                @input="$refs.from.save(filters.date)"
                locale="es"
                type="month"
                color="k-orange-linear">
              </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </data-table>
    <v-dialog
      v-model="dialogBaseGenerator"
      scrollable
      persistent
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar class="k-orange-linear white--text">
          <v-toolbar-title>Generar archivo de campaña</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid px-4>
            <v-layout row wrap>
              <v-flex md12 pr-2>
                <v-select
                  label="Canal"
                  :items="channels"
                  item-text="name"
                  item-value="value"
                  v-model="formBaseGenerator.channel"
                  color="black"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                Archivo excel con cuentas
              </v-flex>
              <v-flex xs12>
                <input type="file" ref="fileBaseGenerator" @change="handleFileFormUpload()">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container fluid pa-0>
            <v-layout row wrap>
              <v-flex xs12 text-xs-right>
                <v-btn color="black" flat @click="dialogBaseGenerator = !dialogBaseGenerator">CANCELAR</v-btn>
                <v-btn class="k-orange-linear-text" flat @click.native="baseGenerator()">GUARDAR</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar class="k-orange-linear white--text">
          <v-toolbar-title>Añadir campaña nueva</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid px-4>
            <v-form ref="form" enctype="multipart/form-data">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="types"
                    color="grey"
                    label="Tipo de campaña"
                    v-model="form.type"
                    v-validate="'required'"
                    data-vv-name="type"
                    data-vv-as="nombre"
                    :error-messages="errors.collect('type')"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    color="grey"
                    label="Nombre de campaña"
                    v-model="form.name"
                    v-validate="'required|max:100'"
                    data-vv-name="name"
                    data-vv-as="nombre"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <v-select
                    label="Canal"
                    :items="channels"
                    item-text="name"
                    item-value="value"
                    v-model="form.channel"
                    v-validate="'required'"
                    data-vv-name="channel"
                    data-vv-as="canal"
                    :error-messages="errors.collect('channel')"
                    color="black"
                  ></v-select>
                </v-flex>
                <template v-if="!form.new_category">
                  <v-flex md5 pl-2 pr-2>
                    <v-select
                      :items="categories"
                      v-model="form.category"
                      label="Categoria"
                      color="gray"
                      autocomplete
                    ></v-select>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex md5 pl-2 pr-2>
                    <v-text-field
                      v-model="form.category"
                      label="Categoria"
                      color="gray"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex md1 class="pt-3">
                  <v-tooltip bottom>
                    <v-btn slot="activator" flat icon small @click="form.new_category = !form.new_category">
                      <v-icon small :class="{'grey--text':form.new_category}">fas fa-{{!form.new_category ? 'plus' : 'times'}}</v-icon>
                    </v-btn>
                    <span>
                      {{ !form.new_category ? 'Haga click si quiere asignar una categoria que no esta en la lista' : 'Haga click si quiere asignar una categoria que esta en la lista'}}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <!-- <v-layout row wrap v-if="form.delivery_option === 'Asignada'">
                <v-flex md12 class="pr-2">
                  <v-menu
                    ref="date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.start_date"
                    transition="scale-transition"
                    min-width="290px"
                    lazy
                    offset-y
                    full-width>
                    <v-text-field
                      slot="activator"
                      v-model="form.start_date"
                      color="grey"
                      append-icon="event"
                      label="Inicio de campaña"
                      readonly>
                    </v-text-field>
                    <v-date-picker
                      v-model="form.start_date"
                      @input="$refs.date.save(form.start_date)"
                      locale="es"
                      color="k-orange-linear">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout> -->
              <v-layout row wrap v-if="form.type != 'internal'">
                <v-flex xs12>
                  <input type="file" ref="file" @change="handleFileUpload()">
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container fluid pa-0>
            <v-layout row wrap>
              <v-flex xs12 text-xs-right>
                <v-btn color="black" flat @click="dialog = !dialog">CANCELAR</v-btn>
                <v-btn class="k-orange-linear-text" flat @click="save()" :disabled="errors.any()">GUARDAR</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <save-dialog
      title="Bases para carga"
      :dialog="dialogBase"
      :form="formBase"
      :route="`generate_file?type=${this.formBase.type}`"
      :edit="false"
      :hasMore="false"
      :more="false"
      :download-dialog="true">
      <template slot="content">
        <v-layout row wrap>
         <v-flex md12>
           <v-select
             :items="typeOfBases"
             v-model="formBase.type"
             label="Tipo de base"
             color="grey"
           ></v-select>
         </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="campaigns"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';
import Sidebar from '@/components/global/Sidebar';
import Detailed from '@/components/panel/management/Detailed';
import DetailedFilters from '@/components/panel/management/filters/Detailed';
import campaignLists from '@/components/campaign/CampaignList';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import DataTable from '@/components/global/DataTable';
import saveDialog from '@/components/global/SaveDialog';
import schedules from '@/components/panel/schedules/Index';
import saveDialogMixin from '@/mixins/saveDialog';
import EventBus from '@/event-bus';
import {mapGetters} from 'vuex';

Vue.component('campaignLists', campaignLists);

export default {
  inject: ['$validator'],
  mixins: [
    deleteDialogMixin,
  ],
  components: {
    DataTable,
    DeleteDialog,
    Detailed,
    saveDialog,
    Sidebar,
    DetailedFilters,
    schedules,
  },
  created() {
    this.startListeningEvents();
    this.getCategories();
    this.getUsers();
  },
  mounted() {
    EventBus.$on('createTemplatecampaign', () => {
      this.dialog = true;
    });
    EventBus.$on('closeModal', () => {
      this.dialogBase = false;
    });
  },
  destroyed() {
    this.stopListeningEvents();
    EventBus.$off('createTemplatecampaign');
  },
  data() {
    return {
      campaigns: [],
      templates: [],
      types: [
        {
          value: 'internal',
          text: 'Base de colektia',
        },
        {
          value: 'external',
          text: 'Base externa',
        },
      ],
      channels: [
        {
          name: 'Email',
          value: 'email',
        },
        {
          name: 'SMS',
          value: 'sms',
        },
        {
          name: 'IVR',
          value: 'ivr',
        },
        {
          name: 'Bot',
          value: 'bot',
        },
        // {
        //   name: 'Call Center',
        //   value: 'human',
        // },
      ],
      filters: {
        search: '',
        status: '',
        date: moment().format('YYYY-MM'),
        sort:'-created_at',
        category: '',
        user_id: '',
      },
      form: {
        name: '',
        type: 'external',
        channel: 'email',
        category: '',
        new_category: false,
      },
      formBase: {
        type: 'email',
      },
      formBaseGenerator: {
        channel: 'email',
      },
      typeOfBases: [
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Telefonico',
          value: 'phone',
        }
      ],
      statuses: [
        {
          value: '',
          name: 'Estados',
        },
        {
          value: 'Enviada',
          name: 'Enviada',
        },
        {
          value: 'Por enviar',
          name: 'Por enviar',
        },
        {
          value: 'Pendiente',
          name: 'Pendiente',
        },
      ],
      sidebarBus: {
        open: 'openCampaignSidebar',
        close: 'closeCampaignSidebar',
        apply: 'applyCampaignFilters',
        unapply: 'unapplyCampaingFilters',
      },
      isInput: true,
      dialog: false,
      dialogBase: false,
      dialogBaseGenerator: false,
      categories: [],
      users: [],
    };
  },
  computed: {
    formatedDate() {
      return moment(this.filters.date, 'YYYY-MM').format('MM/YYYY');
    },
    nameFile() {
      let name = '';
      if (this.filters.category) name += ` con categoría ${this.filters.category}` ;
      if (this.filters.status) name += ` con estado ${this.filters.status}` ;
      if (this.filters.user_id) name += ` del usuario ${this.users.find(x => x.value === this.filters.user_id).text }` ;
      return name;
    },
  },
  methods: {
    baseGenerator() {
      const formData = new FormData();
      formData.append('file', this.formBaseGenerator.file);
      const functionName = 'campaigns_by_accounts';

      this.axios.post('/reports/upload', formData).then((response) => {
        this.$store.commit(
          'SET_DOWNLOAD_CHANNEL',
          `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`,
        );
        this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
          route: 'reports',
          params: {
            filters: {
              filename: response.data,
              channel: this.formBaseGenerator.channel,
            },
            functionName,
          },
        });
        this.formBaseGenerator.file = '';
        this.$refs.fileBaseGenerator.files = [];
        this.dialogBaseGenerator = false;
      });
    },
    generateReport({campaign = 0, campaignName = ''}) {
      let name = '';
      if (campaign !== 0) {
        name += `Gestiones de la campaña ${campaignName}`;
      } else {
        name = `Gestiones de campañas${this.nameFile}`;
      }
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            type: 2,
            dateType: 'month',
            date: this.filters.date,
            campaign,
            campaignCategory: this.filters.category,
            campaignStatus: this.filters.status,
            campaignUser: this.filters.user_id,
            filename: name,
          },
          functionName: 'managementTotal',
        },
      });
    },
    stopListeningEvents() {
      window.Echo.leave('campaigns');
      window.Echo.leave(`company.${this.$auth.user().company.id}.campaigns`);
    },
    startListeningEvents() {
      window.Echo.private(`company.${this.$auth.user().company.id}.campaigns`).listen('.CampaignCreated', (event) => {
        this.$router.push(`/campaigns/${event.campaign.id}/confirm`);
      });
      window.Echo.channel('campaigns').listen('.resend', (event) => {
        if (event.upload === 'failed') {
          EventBus.$emit('modal', event.message);
        } else {
          EventBus.$emit('update');
        }
      });
    },
    getCategories() {
      this.axios.get(`/campaigns/categories?date=${this.filters.date}`).then((response) => {
        this.categories = response.data;
        this.categories.unshift({
          text: 'Categorias',
          value: '',
        });
      }).catch(() => { });
    },
    getUsers() {
      this.axios.get(`/campaigns/users?date=${this.filters.date}`).then((response) => {
        this.users = response.data;
        this.users.unshift({
          text: 'Usuarios',
          value: '',
        });
      }).catch(() => { });
    },
    handleFileUpload() {
      this.form.file = this.$refs.file.files[0];
    },
    handleFileFormUpload() {
      this.formBaseGenerator.file = this.$refs.fileBaseGenerator.files[0];
    },
    save() {
      const formData = new FormData();
      if (this.form.type === 'external') {
        formData.append('file', this.form.file);
      }
      formData.append('type', this.form.type);
      formData.append('name', this.form.name);
      formData.append('channel', this.form.channel);
      formData.append('category', this.form.category);

      this.axios.post('/campaigns', formData).then((response) => {
        this.dialog = false;
        let typeRoute = this.form.type === 'external' ? 'confirm' : 'assigned';
        this.$router.push(`/campaigns/${response.data}/${typeRoute}`);
      }).catch((e) => {
        if (!we.response.data.errors) {
          EventBus.$emit('modal', e.response.data);
        }
      });
    },
    check(){
      return this.checkPermissions([
        'create_campaigns',
      ]);
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        Object.keys(this.form).forEach((key) => {
          if (Array.isArray(this.form[key])) {
            this.form[key] = [];
          } else {
            this.form[key] = '';
          }
        });
        this.$nextTick(() => {
          this.$validator.reset();
          this.errors.clear();
        });
      } else {
        this.getCategories();
      }
    },
    filters: {
      handler() {
        this.getCategories();
        this.getUsers();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
#backdropEmail {
  height: 30px !important;
  padding: 0 !important;
  top: 3px !important;
  background: transparent !important;
  overflow-y: hidden !important;
  overflow-x: auto !important;
}

#highlightsEmail mark {
  background: transparent !important;
}

.card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-container > .card-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}
.card-container > .card-content span.subheading:not(:first-child) {
  color: rgba(0,0,0,.54);
}
.k-orange-linear .card-container > .card-content span.subheading:not(:first-child) {
  color: #fff;
}
#cards div.card:not(.k-orange-linear):hover {
  cursor: pointer;
  background-color: rgba(0,0,0,0.09) !important;
}
.detailed > div:not(.k-orange-linear) .card__text:hover {
  -webkit-transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
    transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
  cursor: pointer;
  background-color: rgba(0,0,0,0.09) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/Index.vue